import React from 'react';
import { Link } from 'react-router-dom';
import './index.css';

type ButtonLinkProps = {
    children?: React.ReactNode;
    className?: string;
    disabled?: boolean;
    fullWidth?: boolean;
    newTab?: boolean;
    onClick?: () => void;
    secondary?: boolean;
    to?: string;
    state?: {};
    href?: string;
};

function ButtonLink({
    children,
    className,
    disabled,
    fullWidth,
    newTab,
    onClick,
    secondary,
    to,
    state,
    href
}: ButtonLinkProps) {
    if (href) {
        return (
            <a
                className={`
                    buttonLink
                    ${fullWidth && 'buttonLink__fullWidth'}
                    ${secondary && 'buttonLink__secondary'}
                    ${disabled && 'buttonLink__disabled'}
                    ${className}
                `}
                target={newTab && '_blank'}
                rel={newTab && 'noopener noreferrer'}
                href={href}
            >
                <div className='buttonLink__content'>
                    {children}
                </div>
            </a>
        );
    }
    
    return (
        <Link
            className={`
                buttonLink
                ${fullWidth && 'buttonLink__fullWidth'} 
                ${secondary && 'buttonLink__secondary'}
                ${disabled && 'buttonLink__disabled'}
                ${className} 
            `}
            to={to}
            state={state}
            onClick={onClick}
        >
            <div className='buttonLink__content'>
                {children}
            </div>
        </Link>
    );
}

export default ButtonLink;